import React from "react";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomButton from "../../../components/CustomButton/CustomButton";
import {
  FormWrapper,
  Form,
  FormGroup,
  LabelWithContainer
} from "../../../components/CustomForm/FormStyles";
import Colors from "../../../themes/Colors";
import useEmpresa from "../../../hooks/useEmpresa";
import { cleanNumber } from "../../../utils/NumberUtil";

const BusquedaPrecertificacionForm = ({
  numeroPrecertificacion,
  onStateChange,
  onSearch,
  isLoading,
  handleKeyPress
}) => {
  const empresa = useEmpresa();

  return (
    <FormWrapper borderColor={Colors.transparent}>
      <Form justifyContent={"space-between"}>
        <FormGroup>
          <LabelWithContainer
            font={empresa?.LETRA_PRINCIPAL}
            labelWidth={"350px"}
            labelHeight={"45px"}
          >
            {`Número precertificación`}
          </LabelWithContainer>
        </FormGroup>
      </Form>

      <Form justifyContent={"space-between"} marginTop={"-20px"}>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Número precertificación"}
            width={"330px"}
            value={numeroPrecertificacion}
            onChange={onStateChange("numeroPrecertificacion", cleanNumber)}
            handleKeyPress={handleKeyPress}
          />
        </FormGroup>
        <FormGroup>
          <CustomButton
            label={"Buscar"}
            onClick={onSearch}
            isLoading={isLoading}
            height={"38px"}
            width={"300px"}
          />
        </FormGroup>
      </Form>
    </FormWrapper>
  );
};

export default BusquedaPrecertificacionForm;